import React, { useEffect, useRef } from "react";
import { DatePicker } from "@progress/kendo-react-dateinputs";

export default function DateFilter({ onDateFilterChange, filter }) {
  const prevOperator = useRef(filter.operator);

  // Reset value when operator changes
  useEffect(() => {
    if (prevOperator.current !== filter.operator) {
      prevOperator.current = filter.operator;

      let value;
      switch (filter.operator) {
        case "ytd":
          value = {
            start: new Date(new Date().getFullYear(), 0, 1),
            end: new Date(),
          };
          break;
        case "mtd":
          value = {
            start: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
            end: new Date(),
          };
          break;
        case "between":
          value = { start: null, end: null };
          break;
        default:
          value = null;
      }

      onDateFilterChange({ ...filter, value });
    }
  }, [filter.operator]);

  const handleDateChange = (event, fieldType) => {
    if (fieldType === "date") {
      onDateFilterChange({
        ...filter,
        value: event.value,
      });
    } else {
      onDateFilterChange({
        ...filter,
        value: {
          start: fieldType === "start" ? event.value : filter.value?.start || null,
          end: fieldType === "end" ? event.value : filter.value?.end || null,
        },
      });
    }
  };

  // convert date string value to date object
  const toDate = (value) => {
    if (!value) return null;
    return value instanceof Date ? value : new Date(value);
  };

  if (filter.operator === "ytd" || filter.operator === "mtd" || filter.operator === "isnull") {
    return null;
  } else if (filter.operator === "between") {
    return (
      <div style={{ display: "flex", gap: "8px" }}>
        <DatePicker placeholder="From" value={toDate(filter.value?.start)} onChange={(event) => handleDateChange(event, "start")} />
        <DatePicker placeholder="To" value={toDate(filter.value?.end)} onChange={(event) => handleDateChange(event, "end")} />
      </div>
    );
  } else {
    return (
      !(filter.value?.start && filter.value?.end) && <DatePicker value={toDate(filter.value)} onChange={(event) => handleDateChange(event, "date")} />
    );
  }
}
